import React, { useState } from 'react'
import { exportToExcel } from '../../utils/exportToExcel'
import { UploadIcon } from 'lucide-react'

const ExportBtn = ({ apiUrl, title }) => {
    const [loading, setLoading] = useState(false)
    return (
        <button
            onClick={() => exportToExcel(apiUrl, title, setLoading)}
            className="btn btn-approve"
            style={{
                gap: 3
            }}
            disabled={loading}
        >
            {loading ? "Exporting..." : <>
                <UploadIcon size={15} />  Export
            </>}
        </button>
    )
}

export default ExportBtn